import React from "react";
import back from "../../../assets/back.svg";
import searcher from "../../../assets/searchInput.svg";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import FieldForceHeadQuarterVersionTable from "./fieldForceVersionTable";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceHeadQuarterVersionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/head-quarter",
      breadcrumb: " / field force / head quarter",
    },
    {
      path: "/field-force/head-quarter/version-list",
      breadcrumb: " / version history",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div>
            <div className="search-container d-flex justify-content-between align-items-center">
              <div className="d-flex w-100">
                <div
                  className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                  onClick={() => navigate("/field-force/head-quarter")}
                >
                  <img src={back} alt="back_btn" />
                  <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                    BACK
                  </span>
                </div>
                <div className="d-flex justify-content-between w-100">
                  <div className="search-box d-flex  align-items-center p-2 ms-3 m-1 mb-2">
                    <img className="styled-SVG" src={searcher} alt="o" />
                    <input
                      value={search}
                      className="search-input text-dark fw_400 px-2"
                      type="text"
                      placeholder="Search user Id, employee id, employee name, etc,."
                      onChange={(e) => {
                        navigate(
                          `/field-force/head-quarter/version-list?page=1${
                            e.target.value ? `&search=${e.target.value}` : ""
                          }${queryString}`
                        );
                      }}
                    />
                  </div>
                  <button
                    onClick={() =>
                      navigate(`/field-force/head-quarter/version-list`)
                    }
                    className="m-2 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>
            <FieldForceHeadQuarterVersionTable
              search={search}
              status={status}
              page_no={page_no}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldForceHeadQuarterVersionList;
